/**
 * Default "start dictation when the control appears" — on for typical mobile/tablet
 * contexts, off for desktop. Parents can pass `[autoStart]="true|false"` explicitly.
 */
export function defaultVoiceAutoStartForPlatform(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
    const coarse = window.matchMedia?.('(pointer: coarse)')?.matches ?? false
    const mobileUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    return coarse || mobileUa
}
